import { ArrowBack, Close } from '@mui/icons-material';
import { Box, Button, Dialog, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import GetPin from './GetPin';
import InputSubmitPin from './InputSubmitPin';
import { getAuth, signInWithPhoneNumber } from 'firebase/auth';
import { app } from 'pages/DeleteUser/firebase';
import { signInWithIdToken } from 'rest_client/publicUserClient';
import { useDispatch } from 'react-redux';
import { setPublicUserLogin } from 'redux/reducers/publicUser';
import { show } from 'redux/reducers/snackbar';
import { translateFirebaseError } from 'utils/utils';

const auth = getAuth(app);

const ModalSignInPin = ({ open, onClose: _onClose }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');
  const dispatch = useDispatch();

  const onSendVerificationCode = async () => {
    try {
      const data = await signInWithPhoneNumber(
        auth,
        phoneNumber,
        window.recaptchaVerifier,
      );
      setResult(data);
    } catch (err) {
      console.log('err', err);
      window.recaptchaVerifier.render();
      throw translateFirebaseError(err?.message) || 'Phone number is invalid';
    }
  };

  const verifyCode = async (code) => {
    try {
      setLoading(true);
      const _data = await result.confirm(code);
      const { data } = await signInWithIdToken({
        phoneNumber,
        idToken: _data._tokenResponse.idToken,
      });
      dispatch(
        setPublicUserLogin({
          user: data.user,
          accessToken: data.accessToken,
        }),
      );
      dispatch(show({ message: 'Sign in successfully', severity: 'success' }));
      setStep(0);
      setPhoneNumber('');
      _onClose();
    } catch (err) {
      let errorMessage =
        typeof err === 'string' ? err : err?.message || 'Incorrect code';
      setLoading(false);
      dispatch(
        show({
          message: translateFirebaseError(errorMessage),
          severity: 'error',
        }),
      );
    }
    setLoading(false);
  };

  const onClose = () => {
    if (loading) return;
    _onClose();
    setStep(0);
    setPhoneNumber('');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={'xs'}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
        },
      }}
    >
      <Box display={'flex'} pt={'6px'} px={'4px'}>
        <Box flex={1}>
          {step > 0 && (
            <Button
              sx={{
                mt: 1,
                ml: 1,
                color: 'black',
              }}
              startIcon={<ArrowBack />}
              onClick={() => setStep(0)}
            >
              Back
            </Button>
          )}
        </Box>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
      <Box p={'15px'} position={'relative'}>
        <GetPin
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          setStep={setStep}
          setLoading={setLoading}
          step={step}
          onSendVerificationCode={onSendVerificationCode}
        />
        {step === 1 && (
          <InputSubmitPin
            loading={loading}
            phoneNumber={phoneNumber}
            verifyCode={verifyCode}
            onSendVerificationCode={onSendVerificationCode}
          />
        )}
      </Box>
      {/* <div id="recaptcha-container"></div> */}
    </Dialog>
  );
};

export default ModalSignInPin;
